import React from "react";
import { alpha } from "@mui/material/styles";
import { Avatar, CardContent, Chip, Stack, Typography, useTheme } from "@mui/material";

import { DashboardCard, SmallLabel } from "./DashboardCard";

function KpiCard({ icon, value, label, subLabel, delta }) {
  const theme = useTheme();

  return (
    <DashboardCard>
      <CardContent sx={{ p: 5, "&:last-child": { pb: 5 } }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Avatar sx={{ bgcolor: alpha(theme.palette.primary.main, 0.12), color: "primary.main", width: 40, height: 40 }}>
            {icon}
          </Avatar>
          {delta ? (
            <Chip label={delta} size="small" sx={{ bgcolor: alpha("#16a34a", 0.12), color: "#16a34a", fontWeight: 700 }} />
          ) : null}
        </Stack>
        <Typography variant="h4" fontWeight={800}>{value}</Typography>
        <SmallLabel variant="body1" sx={{ mt: 0.5 }}>{label}</SmallLabel>
        {subLabel ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{subLabel}</Typography>
        ) : null}
      </CardContent>
    </DashboardCard>
  );
}

export default KpiCard;
